import React, { useEffect, useReducer } from 'react';
import AdvancedChecklistBody from './AdvancedChecklistBody';
import AdvancedChecklistFooter from './AdvancedChecklistFooter';
import AdvancedChecklistHeader from './AdvancedChecklistHeader';
import useAdvancedChecklist from './useAdvancedChecklist';
import {
    AdvancedChecklistReducer,
    setAdvancedChecklistItems,
    setAdvancedChecklistFilters,
    setAdvancedChecklistSelectedFilters,
} from './state';
import { FilterOptionsType } from './state/AdvancedChecklist.actions';
import { ProductType } from '../../../../../../components/menu/products/ItemsContainer';
export interface IAdvancedChecklist {
    // List data - typed any so you can pass any list you want
    listData: any[];
    // What label to show for each item in the list
    mainLabelKey: string;
    // Pass this if you want to show another label underneath the main label
    subLabelKey?: string;
    // Determines whether the cancel and submit is going to be handled somewhere else or in here
    hasSubmitCancelButtons?: boolean;
    // Pass this if you are handling the submit outside of this compoent otherwise try to avoid it
    onItemSelectionChange?: (selectedItems: any[]) => void;
    // Function to be called once submited
    onSubmit?: (selectedItems: any[]) => void;
    // Function to be called once cancelled
    onCancel?: () => void;
    // Pass if you have selected items already
    selectedItems?: any[];
    // Filters
    filterOptions?: FilterOptionsType[];
    // Pass if you want create new product button
    onCreate?: (selectedItems: any[]) => void;
    // Whether to show the 'Main Item' tag
    hasMainItemTag?: boolean;
    // Disable item type selection - Main/Extra
    disableItemTypeSelection?: ProductType;
    // Toolbar and Edit/View item section
    itemToolbar?: (id: string, getSelected: () => any[]) => JSX.Element;
    // Virtualized list or a normal list
    isVirtualizeList?: boolean;
    // Info card to appear on the list - Adds an 8rem bottom padding to body
    InfoCard?: React.ReactNode;
    // Specify this if the item data doesn't have an "id" field
    idKey: string;
    // Optional description for the header
    headerDescription?: string;
    // Whether to store and persist the selected filters
    persistSelectedFilters?: boolean;
    // Disables the submit button if user hasn't selected any items yet
    mandatorySelection?: boolean;
    // Alternative submit button text
    submitButtonText?: string;
    // Alternative cancel button text
    cancelButtonText?: string;

    isDisabled?: boolean
}

function AdvancedChecklist(props: IAdvancedChecklist) {
    const [state, dispatch] = useReducer(AdvancedChecklistReducer, {
        listItems: [],
        filtersList: [],
        selectedFiltersIDs: [],
    });
    const { getSelected, getSelectedCount, selectAll, selectNone, onSearchChange } = useAdvancedChecklist(
        state,
        (items: any) => dispatch(setAdvancedChecklistItems(items)),
        props.mainLabelKey,
        props.disableItemTypeSelection,
    );
    useEffect(() => {
        if (props.onItemSelectionChange !== undefined) {
            console.log(props);
            props.onItemSelectionChange(getSelected());
        }
        // eslint-disable-next-line
    }, [state.listItems]);

    useEffect(() => {
        const tempData = props.listData?.map((item) => {
            return {
                ...item,
                selected: props.selectedItems?.find((selectedItem) => selectedItem[props.idKey] === item[props.idKey])
                    ? true
                    : false,
            };
        });
        dispatch(setAdvancedChecklistItems(tempData));
        if (props.persistSelectedFilters && window.localStorage.getItem('selectedFiltersIDs')) {
            const selectedFilterIDs: string[] = JSON.parse(window.localStorage.getItem('selectedFiltersIDs') ?? '');
            dispatch(setAdvancedChecklistSelectedFilters([...selectedFilterIDs]));
        } else {
            window.localStorage.removeItem('selectedFiltersIDs');
        }
    }, [props.listData, props.selectedItems, props.idKey, props.persistSelectedFilters]);

    useEffect(() => {
        dispatch(setAdvancedChecklistFilters(props.filterOptions ?? []));
        // eslint-disable-next-line
    }, [props.filterOptions]);

    function onItemSelection(id: string) {
        let tempList = state.listItems;
        const itemIndex = state.listItems.findIndex((item: any) => item[props.idKey] === id);
        tempList[itemIndex].selected = !tempList[itemIndex].selected;
        dispatch(setAdvancedChecklistItems([...tempList]));
    }

    function onSubmit() {
        if (props.onSubmit) {
            props.onSubmit(getSelected());
        }
    }

    function onCancel() {
        if (props.onCancel) {
            props.onCancel();
        }
    }

    function onCreate() {
        if (props.onCreate) {
            props.onCreate(getSelected());
        }
    }
    console.log(props, 'FFGGSDF');

    return (
        <div
            style={{
                height: '100%',
                width: '100%',
            }}
        >
            <AdvancedChecklistHeader
                persistSelectedFilters={props.persistSelectedFilters}
                headerDescription={props.headerDescription}
                onCreate={props.onCreate ? onCreate : undefined}
                dispatch={dispatch}
                state={state}
                selectAll={selectAll}
                selectNone={selectNone}
                selectedItemsCount={getSelectedCount()}
                onSearchChange={onSearchChange}
            />
            <AdvancedChecklistBody
                itemToolbar={props.itemToolbar}
                getSelected={getSelected}
                {...props}
                subLabelKey={props.subLabelKey}
                listData={state.listItems}
                onItemSelection={onItemSelection}
                hasMainItemTag={props.hasMainItemTag}
                disableItemTypeSelection={props.disableItemTypeSelection}
            />
            {props.hasSubmitCancelButtons && (
                <AdvancedChecklistFooter
                    isDisabled={props.isDisabled}
                    cancelButtonText={props.cancelButtonText}
                    submitButtonText={props.submitButtonText}
                    getSelected={getSelected}
                    mandatorySelection={props.mandatorySelection}
                    state={state}
                    onCancel={onCancel}
                    onSubmit={onSubmit}
                />
            )}
        </div>
    );
}

AdvancedChecklist.defaultProps = {
    idKey: 'id',
};
export default AdvancedChecklist;
